export default __webpack_public_path__ + "static/media/membrana.aebc12e6.png";